import * as moment from 'moment';
import * as util from './util';
import 'slick-carousel';
import { Fancybox } from "@fancyapps/ui/dist/index.umd.js";
import {default as Modal} from './modal.js';

import customSelect from './customselect';
import customInputNumber from './form-number';
import {default as Preloader} from './preloader.js';
import {CheckAvailabilityForm} from './check-availability.js';
import {default as BookingModel} from './model.js';

function BookingForm($wrapper) {
    this.$wrapper = $wrapper;
}

BookingForm.prototype.getDom = function() {
	return this.$wrapper;
}

BookingForm.prototype.changePackagePax = function(roomidx, adults) {
    var $roomwrapper = this.getRoomDom(roomidx);

    $roomwrapper.attr('data-packageadults', adults);
 
    var $pricesel = $obj.parents('.details-content').find('.price-select');
    $pricesel.find('input').prop('checked', true);
    $pricesel.find('input').change();

    var priceone = parseFloat($pricesel.find('.package-radio').attr('data-package-priceper'));
    var package_price = priceone * adults;

    $pricesel.find('label').html('US$ ' + package_price);
}

BookingForm.prototype.changeRoomFuncSaf = function(roomidx) {
    var roomparams = {
        "room": roomidx
    };

    this.reloadRoom(roomparams);
}

BookingForm.prototype.getRoomDom = function(roomidx) {
    return this.$wrapper.find('.fullroomdiv[data-roomidx=' + roomidx + ']');
}

BookingForm.prototype.getRoomsDom = function() {
    return this.$wrapper.find('.fullroomdiv');
}

BookingForm.prototype.getCouponWrapper = function() {
    return $wrapper.find('#couponDiv');
}

BookingForm.prototype.updateRoomsWrapper = function(html) {
    const $panelBody = this.$wrapper.find('.rooms-wrapper .panel-body');

    $panelBody.html(html);
};


const BookingPage = {
    init: function($body) {
		this.$root = $body;
		const $bookdetailsform = $body.find('form.bookdetailsform');
		const $bookform = $body.find('form.bookform');

        const model = new BookingModel();
        this.checkAvailabilityForm = new CheckAvailabilityForm($bookform, model);
        this.bookingDetailsForm = new BookingForm($bookdetailsform, model); 

		const _this = this;

        $bookform.on('fetched', function(e, data) {
            $bookdetailsform.find('input.checkindateval').val($bookform.find('input.checkindate').val());
            $bookdetailsform.find('input.checkoutdateval').val($bookform.find('input.checkoutdate').val());
            $bookdetailsform.find('input.nightsval').val($bookform.find('input.nights').val());
            $bookdetailsform.find('input.roomscountval').val(1);
            $bookdetailsform.find('input.currency').val($bookform.find('.currency').find('option:selected').attr('value'));
            $bookdetailsform.find('input.selected-room-index').val(0);
            $('.side .panel').each(function(index, panel) {
                if ($(panel).is('.reward')) {
                    $(panel).show();
                }

                if ($(panel).is('.whybook')) {
                    $(panel).hide();
                }

                if ($(panel).is('.summary')) {
                    $(panel).hide();
                }
            });

            if (typeof data.summary_html != 'undefined') {
                const $summaryPanel = _this.$root.find('.summary');
                const $summaryPanelBody = $summaryPanel.find('.panel-body');
                $summaryPanelBody.html(data.summary_html);

                $summaryPanel.show();

                $('.panel.continue').show();
                $('.panel.coupon').show();
                $('.panel.whybook').hide();
            } else {
                $('.panel.continue').hide();
                $('.panel.coupon').hide();
                $('.panel.summary').hide();
                $('.panel.whybook').show();
            }

            _this.handleReloadSuccess('all', data);

			$([document.documentElement, document.body]).animate({
				scrollTop: $bookdetailsform.offset().top - 32
			}, 1000);
        });

		$body.on('click', '.more', function(e) {
			const $target = $(e.target);
			const $panelBody = $target.parents('.panel-body');
			const $summaryDetails = $panelBody.find('.summary-details');
			const $totals = $panelBody.find('.sub-total');
			if ($summaryDetails.is(':visible')) {
				$summaryDetails.hide();
				$totals.hide();
			} else {
				$summaryDetails.show();
				$totals.show();
			}
		});

		$body.on('click', '.btn-continue', function(e) {
			e.preventDefault();

			const $this = $(e.target);

			const currencyCode = $bookdetailsform.find('input.currency').val();

			const continueFunc = function() {
				const fetchUrl = $bookdetailsform.attr('action');
				const formData = $bookdetailsform.serialize();

				$.ajax(fetchUrl, {
					data: formData,
					method: 'POST'
				}).done(function(responseData) {
					const url = responseData.data.next_step_url;
					window.location = url;
				});
			};

			if ($this.hasClass('require-nic') && currencyCode == 'LKR') {
				e.preventDefault();

				Modal.show('nic-modal', {
					onShown: function($modal) {
						const $verifyNICForm = $modal.find('.verify-nic-form');
						$verifyNICForm.on('submit', function(e) {
							e.preventDefault();

							const url = $verifyNICForm.attr('action');
							let validateNICformData = $verifyNICForm.serialize();
							validateNICformData += '&currency=LKR';

							$.ajax(url, {
								data: validateNICformData,
								method: 'POST'
							}).done(function(responseData) {
								if (responseData.status == "success") {
									continueFunc();
								}
							});
						});
					}
				});
			} else {
				continueFunc();
			}
		});

		this.initBookingDetails();
		this.initCouponCode();
		this.slidingSide();
    },
	initCouponCode: function() {
		const _this = this;

		_this.$root.on('click', '.add-coupon', function(e) {
			e.preventDefault();

			const $codeField = _this.$root.find('.code');

			_this.$root.find('.applied_code').val($codeField.val());

			 _this.reload();
		});
	},
	initBookingDetails: function() {
		const _this = this;

		const $bookdetailsform = this.bookingDetailsForm.getDom();

		$bookdetailsform.on('click', 'button.select-room-type', function(e) {
			e.preventDefault();

			const $target = $(e.target);
			$target.parents('.subpanel').find('.roomtype').prop('disabled', false)
				.val($(this).attr('data-roomtypeid'));

			const $roomType = $target.parents('.room-type-item');
			const $room = $roomType.parents('.room');

			let grooms = [];

			grooms.push({
				item_id: $roomType.attr('data-id'),
				item_name: $roomType.find('.room-type-name').html(),
				item_category: 'Accommodation',
				price: $roomType.find('.price .value').html(),
				index: $room.attr('data-idx')
			});

			dataLayer.push({
				"ecommerce": null
			});

			dataLayer.push({
				"event": 'select_item',
				"ecommerce": {
					"item_list_id": 'available_rooms',
					"item_list_name": 'Available Rooms',
					"items": grooms
				}
			});

			_this.reload();
		});

		$bookdetailsform.on('click', '.add-package', function(e) {
			e.preventDefault();

			const $addonPackageIdField = $bookdetailsform.find('input.addon-package-id');
			$addonPackageIdField.prop('disabled', false);
			$addonPackageIdField.val($(this).attr('data-packageid'));

			const $addonPackageAdultsField = $bookdetailsform.find('input.addon-package-adults');
			$addonPackageAdultsField.prop('disabled', false);
			$addonPackageAdultsField.val($(this).attr('data-packageadults'));

			_this.reload();
		});

		$bookdetailsform.on('click', '.remove-package', function(e) {
			e.preventDefault();

			$bookdetailsform.find('input.addon-package-id').val('');
			$bookdetailsform.find('input.addon-package-adults').val('');

			_this.reload();
		});

		$bookdetailsform.on('click', '.edit-room', function(e) {
			const $target = $(e.target);
			const roomIdx = $target.parents('.room').attr('data-idx');

			const $selectedRoomIndexField = $bookdetailsform.find('input.selected-room-index');
			$selectedRoomIndexField.val(roomIdx);

			_this.reload();
		});

		$bookdetailsform.on('click', '.add-room', function(e) {
			e.preventDefault();
			const $field = $bookdetailsform.find('input.roomscountval');
			$field.val(parseInt($field.val())+1);

			const $room = $bookdetailsform.find('.room:last');
			const roomIdx = parseInt($room.attr('data-idx'));
			
			const $selectedRoomIndexField = $bookdetailsform.find('input.selected-room-index');
			$selectedRoomIndexField.val(roomIdx+1);

			_this.reload();
		});

		$bookdetailsform.on('click', '.remove-room', function(e) {
			e.preventDefault();
			const $field = $bookdetailsform.find('input.roomscountval');
			$field.val(parseInt($field.val())-1);

			const $button = $(this);
			const $panel = $button.parents('.room');
			
			const roomIdx = parseInt($panel.attr('data-idx'));

			$bookdetailsform.find('.room').slice(roomIdx+1).each(function(index1, room) {
				const $room = $(room);

				$room.find('input,select').each(function(index2, field) {
					const $field = $(field);
					$field.attr('name', $field.attr('name').replace(/\[([0-9]+)\]/i, "[" + (roomIdx+index1) + "]"));
				});

			});

			$bookdetailsform.find('.rooms-wrapper .room').eq(roomIdx).remove();

			const $selectedRoomIndexField = $bookdetailsform.find('input.selected-room-index');
			const selectedRoomIndex = parseInt($selectedRoomIndexField.val());

			if (selectedRoomIndex > roomIdx) { 
				$selectedRoomIndexField.val(selectedRoomIndex-1);
			}

			_this.reload();
		});
		
		$bookdetailsform.on('change', '.addon-package-adults', function(e) {
			e.preventDefault();

			_this.reload();
		});

		const $roomsWrapper = $bookdetailsform.find('.rooms-wrapper');

		$roomsWrapper.on('change', 'input,select', function(e) {
			e.preventDefault();

			const $target = $(e.target);
			const $preferences = $target.parents('.room-preferences');

			if ($target.is('.adults')) {
				const $adultInput = $preferences.find('input.adults');
				const $childInput = $preferences.find('input.child');

				const adults = parseInt($adultInput.val());
				let children = parseInt($childInput.val());
				let maxChildren = 4 - adults;

				if (adults == 3 || children > maxChildren) {
					maxChildren = 0;
					children = 0;
				}

				$childInput.attr('max', maxChildren).val(children);
			}

			if ($target.is('.child')) {
				const $adultInput = $preferences.find('input.adults');
				const $childInput = $preferences.find('input.child');
				const $infantInput = $preferences.find('input.infants');

				const adults = parseInt($adultInput.val());
				const children = parseInt($childInput.val());
				let infants = parseInt($infantInput.val());

				let maxInfants = 4 - (adults + children);

				if (adults == 3 || infants > maxInfants) {
					maxInfants = 0;
					infants = 0;
				}

				$infantInput.attr('max', maxInfants).val(infants);
			}

			if ($target.is('.roomtype')) {
				const $room = $target.parents('.room');
				const $beddingOption = $room.find('select.bedding');
				$beddingOption.val(1);
			}

			_this.reload('all');
		});
	},
	slidingSide: function() {
		return;
		const $main = this.$root.find('.main');
		const $side = this.$root.find('.side');

		const mainHeight = $main.height();
		const sideHeight = $side.height();

		$(window).off('scroll.side');
		$side.css({'position': 'static'});

		if (mainHeight > sideHeight + 100) {
			$(window).on('scroll.side', function() {
				const windowScrollTop = $(window).scrollTop();
				const windowHeight = $(window).height();
				const windowScrollBottom = windowScrollTop + windowHeight;

				const mainOffsetTop = $main.offset().top;
				const mainHeight = $main.height();
				const mainOffsetBottom = mainOffsetTop + mainHeight;

				const sideOffsetTop = $side.offset().top;
				const sideHeight = $side.height();
				const sideOffsetBottom = sideOffsetTop + $side.height();

				const deltaTop = windowScrollTop - mainOffsetTop;
				const deltaBottomWindow = windowScrollBottom - mainOffsetBottom;
	  
				if (deltaTop >= 0 && (deltaTop <= mainHeight - sideHeight - 20)) {
					$side.css({'position': 'absolute', 'top': deltaTop + 20, 'right': 0, 'width': $side.width()});
				} else {  
					if (deltaTop < 0) {
						$side.css({'position': 'absolute', 'top': 0, 'right': 0, 'width': $side.width()});
					} else if (deltaBottomWindow > 0) {
						$side.css({'position': 'absolute', 'top': mainHeight - sideHeight, 'right': 0, 'width': $side.width()});
					}
				}
			});
		}
	},
	handleReloadSuccess: function(type, data) {
		if (typeof type == 'undefined') {
			type = 'all';
		}

		const $bookdetailsform = this.bookingDetailsForm.getDom();

		const grooms = [];

		if (type == 'all') {
			const $rooms = $bookdetailsform.find('.rooms-wrapper .panel-body');
			$rooms.html(data.rooms_html);

			$bookdetailsform.find('select.roomtype').each(function(index, select) {
				customSelect($(select));
			});

			$rooms.find('.room').each(function(index, room) {
				const $room = $(room);

				if ($room.is('.select-room-type')) {
					const $roomtypeSelect = $room.find('.roomtype');
					$roomtypeSelect.prepend('<option value="" selected>Please choose</option>');

					$room.on('click', '.room-type-item .image', function(e) {
						const $img = $(e.currentTarget);
						const ajaxUrl = $img.attr('data-ajax');
						$.ajax(ajaxUrl, {
							method: 'GET'
						}).done(function(responseData) {
							if (responseData.status == "success") {
								const galleryOptions = {};
								let photos = [];
								$.each(responseData.data, function(index, item) {
									photos.push({
										src: item.sizes['big_l'],
										thumb: item.sizes['std'],
										caption: item.title
									});
								});
								new Fancybox(photos, galleryOptions);
							}
						});
					});
				}

				if (!$room.is('.room-summary')) {
					customInputNumber($room.find('.adults'));
					customInputNumber($room.find('.child'));
					customInputNumber($room.find('.infants'));
				}

				const $adultInput = $room.find('input.adults');
				const $childInput = $room.find('input.child');
				const $infantInput = $room.find('input.infants');

				const adults = parseInt($adultInput.val());
				const children = parseInt($childInput.val());
				const infants = parseInt($infantInput.val());

				let maxChildren = 4 - adults;
				let maxInfants = 4 - (adults + children);

				if (adults == 3) {
					maxInfants = 0;
					maxChildren = 0;
				}

				$childInput.attr('max', maxChildren);
				$infantInput.attr('max', maxInfants);
				
				$room.find('.room-type-item').each(function(index, roomType) {
					const $roomType = $(roomType);
					grooms.push({
						item_id: $roomType.attr('data-id'),
						item_name: $roomType.find('.room-type-name').html(),
						item_category: 'Accommodation',
						price: $roomType.find('.price .value').html(),
						quantity: $roomType.find('.rooms-count').attr('data-value')
					});
				});
			});

			const $checkinInput = this.checkAvailabilityForm.getCheckinInput();
			const startDate = $checkinInput.data('daterangepicker').startDate;
			const endDate = $checkinInput.data('daterangepicker').endDate;

			dataLayer.push({
				"event": 'view_item_list',
				"ecommerce": {
					"item_list_id": 'available_rooms',
					"item_list_name": 'Available Rooms',
					"check_in": startDate.format(this.checkAvailabilityForm.getInternalDateFormat()),
					"check_out": endDate.format(this.checkAvailabilityForm.getInternalDateFormat()),
					"items": grooms
				}
			});
		}

		if (typeof data.summary_html != 'undefined' && data.summary_html.length) {
			const $summary = this.$root.find('.summary');
			$summary.find('.panel-body').html(data.summary_html);
			$summary.show();

			this.$root.find('.continue').show();

			this.$root.find('.panel.whybook').hide();
			this.$root.find('.panel.coupon').show();
		} else {
			this.$root.find('.panel.whybook').show();
		}

		this.slidingSide();

	/*
		if (typeof data.packages_html != 'undefined') {
			const $packagesPanelBody = $bookdetailsform.find('.packages-wrapper .panel-body');
			$packagesPanelBody.html(data.packages_html);

			if ($bookdetailsform.find('.selected-package').length) {
				$bookdetailsform.find('.select-package').hide();

				customInputNumber($packagesPanelBody.find('input.addon-package-adults'));

			} else {
				$bookdetailsform.find('.available-packages').slick({
					dots: false,
					infinite: true,
					speed: 300,
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplay: false,
					pauseOnHover: false,
					autoplaySpeed: 4000,
					responsive: [{
						breakpoint: 1024,
						settings: {
						  slidesToShow: 3,
						  slidesToScroll: 3,
						  infinite: true,
						  dots: true
						}
					  },
					  {
						breakpoint: 992,
						settings: {
						  slidesToShow: 2,
						  slidesToScroll: 2
						}
					  },
					  {
						breakpoint: 576,
						settings: {
						  slidesToShow: 1,
						  slidesToScroll: 1
						}
					  }
					]
				});
			}

			$bookdetailsform.find('.packages-wrapper').show();
		}
	*/
	},
	reload: function(type) {
		if (typeof type == 'undefined') {
			type = 'all';
		}

		Preloader.start();

		const $bookdetailsform = this.bookingDetailsForm.$wrapper;
		const fetchUrl = $bookdetailsform.attr('data-update-url');
		const formData = $bookdetailsform.serialize();

		const $roomsWrapper = $bookdetailsform.find('.rooms-wrapper');
		const $roomsPanel = $roomsWrapper.find('.panel');
		const $roomsPanelBody = $roomsPanel.find('.panel-body');
		/*
		$roomsPanelBody.append('<div class="loading-overlay"><div class="background"></div><div class="content">Loading...</div></div>');
		$roomsPanel.addClass('loading');
		*/

		const $summary = this.$root.find('.side .summary');
		const $summaryPanelBody = $summary.find('.panel-body');
		/*
		$summaryPanelBody.append('<div class="loading-overlay"><div class="background"></div><div class="content">Loading...</div></div>');
		$summary.addClass('loading');
		*/

		const _this = this;

		$.ajax(fetchUrl, {
			data: formData,
			method: 'POST'
		}).done(function(responseData) {
			if (responseData.status == 'error') {
				//window.location = 'booking';
				return;
			}

			Preloader.end(); 

			_this.handleReloadSuccess(type, responseData.data);
		});
	}
};

export default BookingPage;